// extracted by mini-css-extract-plugin
export default {"roundIcon":"RoundIcon_roundIcon__2Ejsh","paddedShadow":"RoundIcon_paddedShadow__0e7P8","roundIconBorder":"RoundIcon_roundIconBorder__l2Cqs"};